import { t } from 'i18next';
import { FC } from 'react';
import { Stack } from '../../../components/stack/Stack';
import { asset } from '../../../services/assetResolverService';
import { Avatar } from '../../../components/avatar/Avatar';
import { IRioSelectProps } from '../../../components/presentational/select/types';
import { RioSelect } from '../../../components/presentational/select/Select';
import { SpecIcon } from '../../wow/components/SpecIcon';
import { safeCharacterName } from '../../../../common/utils';
import { TCharacterSummary } from '../../../../types/raidTypes';

export type PovSelectOptionValue = number | 'multi-pov';

type RosterItem = TCharacterSummary | string;

interface IPOVSelectProps extends IRioSelectProps<RosterItem, PovSelectOptionValue, false, false> {}

const POVSelect: FC<IPOVSelectProps> = (props) => {
  return (
    <RioSelect
      {...props}
      options={['multi-pov', ...(props.options || [])]}
      getOptionValue={(option) => (typeof option === 'string' ? option : option.id)}
      formatOptionLabel={(option) => {
        if (typeof option === 'string') {
          return (
            <Stack alignItems="center">
              <Avatar
                src={asset('/images/wow/icons/medium/inv_misc_selfiecamera_01.jpg')}
                size={22}
                border
                className="rio-shadow--small"
              />
              <span>{t('videos:pov-selection.multi-pov-entry')}</span>
            </Stack>
          );
        }

        const character = option;

        return (
          <Stack alignItems="center">
            <Avatar size={22} className="rio-shadow--small rio-border--light">
              <SpecIcon class={character.class.slug} spec={character.spec.slug} size={20.4} />
            </Avatar>
            <span>{`${t('common:class-spec', {
              class: t(`game:classes.${character.class.slug}.name`),
              spec: t(`game:specs.${character.class.slug}.${character.spec.slug}.name`)
            })}`}</span>{' '}
            ({safeCharacterName(character.name)})
          </Stack>
        );
      }}
    />
  );
};

export default POVSelect;
